import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ApplicationStore } from '@core/stores/application.store';

export const AuthGuard: CanActivateFn = () => {
  const applicationStore = inject(ApplicationStore);

  if (applicationStore.authenticated()) {
    return true;
  }

  return new Promise((resolve, _) =>
    setTimeout(() => resolve(true), 1000)
  );

};
